export * from './contact.component';
export * from './contact.route';
export * from './contact.module';
export * from './contact.model';
export * from './contact.service';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contact/index.ts